import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route  } from 'react-router-dom';
import { RespuestasProvider } from './contexts/RespuestasContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Layout } from './components/Layout';

//PAGINAS
import HomePage from './pages/HomePage';
import BebesPage from './pages/BebesPage';
import EmbarazadaPage from './pages/EmbarazadaPage';
import SessionTypePage from './pages/SessionTypePage';
import KidsandfamilyPage from './pages/KidsandfamilyPage';
import QuincesPage from './pages/QuincesPage';

//DATOS JSON
import datawelcome from './data/datawelcome.json';
import sesiontypes from './data/sesiontypes.json';
import ofertaskids from './data/ofertaskids.json';
import ofertasbebes from './data/ofertasbebes.json';
import ofertasembarazadas from './data/ofertasembarazadas.json';
import ofertasquinces from './data/ofertasquinces.json';


let rutaCarpeta = 'pictures';

// Nombre de la imagen
let nombreImagen = '01.jpg';

// Construir la URL completa de la imagen
let urlImagen = `/${rutaCarpeta}/${nombreImagen}`;

function App() {
  const [isMobile, setIsMobile] = useState(false);

  // const handleResize = () => {
  //   setIsMobile(window.innerWidth <= 768); // Puedes ajustar este valor según tus necesidades
  // };

  // useEffect(() => {
  //   handleResize(); // Llamamos a la función al cargar la página
  //   window.addEventListener('resize', handleResize);

  //   // Limpiar el event listener al desmontar el componente
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, []);




  return (
    <ThemeProvider>
      <RespuestasProvider>
        <Layout isMobile={isMobile}>
          <Routes>
              <Route exact path='/' element={<HomePage isMobile={isMobile} datawelcome={datawelcome} urlImagen={urlImagen} />} />
              <Route exact path='/sesiontype' element={<SessionTypePage sesiontypes={sesiontypes} />} />
              <Route path='/ofertaskids' element={<KidsandfamilyPage ofertaskids={ofertaskids} />} />
              <Route path='/bebes' element={<BebesPage ofertasbebes={ofertasbebes} />} />
              <Route path='/embarazadas' element={<EmbarazadaPage ofertasembarazadas={ofertasembarazadas} />} />
              <Route path='/quinces' element={<QuincesPage ofertasquinces={ofertasquinces} />} />
          </Routes>
        </Layout>
      </RespuestasProvider>
    </ThemeProvider>
  );
}

export default App;
